module.exports = __webpack_public_path__ + "man.e3e151f3dcf74b363b67.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/pages/img/title-bg/man.jpg
// module id = ../../../../../src/assets/pages/img/title-bg/man.jpg
// module chunks = styles